import React, { useEffect, useState } from "react";
import { AppLayout, PageHeader } from "@/components/AppLayout";
import { DataTable, Toolbar, SearchInput, Select } from "@/components/Primitives";
import { api, fmtDate } from "@/lib/api";

const MODULES = ["", "receiving", "processing", "stock", "orders", "dispatch", "damages", "finance", "documents", "customers", "suppliers", "products", "users"];

export default function Audit() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [module, setModule] = useState("");

  useEffect(() => {
    (async () => {
      const params = {};
      if (module) params.module = module;
      const r = await api.get("/audit", { params });
      setItems(r.data);
    })();
  }, [module]);

  const filtered = items.filter((x) => !q || JSON.stringify(x).toLowerCase().includes(q.toLowerCase()));

  return (
    <AppLayout>
      <PageHeader title="Audit Trail" subtitle="Every create, update, delete, allocation and dispatch is recorded." />
      <Toolbar>
        <SearchInput value={q} onChange={setQ} placeholder="Search by user, ref, details..." />
        <Select value={module} onChange={(e) => setModule(e.target.value)} className="max-w-[200px]">
          {MODULES.map((m) => <option key={m} value={m}>{m ? m.charAt(0).toUpperCase() + m.slice(1) : "All modules"}</option>)}
        </Select>
        <div className="text-xs text-stone-500 ml-auto">{filtered.length} events</div>
      </Toolbar>

      <DataTable
        columns={[
          { header: "Time", mono: true, render: (r) => fmtDate(r.created_at) },
          { header: "User", mono: true, render: (r) => r.user_email || "—" },
          { header: "Module", render: (r) => <span className="text-xs uppercase tracking-wider px-2 py-0.5 rounded-sm bg-stone-100">{r.module}</span> },
          { header: "Action", render: (r) => <span className="text-xs font-semibold uppercase tracking-wider text-emerald-900">{r.action}</span> },
          { header: "Reference", mono: true, render: (r) => r.reference_number || (r.reference_id ? r.reference_id.slice(0, 8) + "…" : "—") },
          { header: "Details", key: "details" },
        ]}
        rows={filtered}
      />
    </AppLayout>
  );
}
